import {
  IonCard,
  IonCardContent,
  IonText,
  IonLabel,
  IonList,
  IonItem,
  useIonAlert,
} from "@ionic/react";
import { useContext } from "react";
import { TranslationsContext, TranslationMessagesContext } from "../util/Translations";
import { useHistory } from "react-router";

interface Inspection {
  id: string;
  name: string;
  required: boolean;
  status: "Completed" | "Not Complete" | "Failed";
  group: "Pre Job" | "Inspection" | "Post Job";
  inspectionId: number;
}

interface Props {
  title: string;
  inspections: Inspection[];
  workOrderId?: string;
  inspectionAllowed?: boolean;
  woMaxStatus?: string;
  onInspectionClick?: (inspection: Inspection) => void;
  isEquipmentContext?: boolean;
  equipmentId?: string;
}

const InspectionGroupList: React.FC<Props> = ({
  title,
  inspections,
  workOrderId,
  inspectionAllowed = true,
  woMaxStatus = "",
  onInspectionClick,
  isEquipmentContext = false,
  equipmentId,
}) => {
  const history = useHistory();
  const { translations } = useContext(TranslationsContext);
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [presentAlert] = useIonAlert();
  const handleInspectionClick = (inspection: Inspection) => {
    if (onInspectionClick) {
      onInspectionClick(inspection);
      return;
    }
    if (isEquipmentContext) {
      if (!equipmentId) {
        return;
      }
      const encodedEq = encodeURIComponent(equipmentId);
      const route = `/Equipment/${encodedEq}/inspection/${inspection.id}`;
      history.push(route);
      return;
    }

    if (!workOrderId) {
      return;
    }

    if (!inspectionAllowed) {
      presentAlert({
        header: translatedMessages["WOApprovalNeeded"]?.MessageText.replace("@1", woMaxStatus),
        buttons: [{ text: translations["lbl_btn_ok"] || "OK" }],
      });
      return;
    }

    const encodedWo = encodeURIComponent(workOrderId);
    const isCompleted = inspection.status === "Completed";
    const route = `/workorder/${encodedWo}/inspection/${inspection.id}${
      isCompleted ? "?readonly" : ""
    }`;
    history.push(route);
  };

  return (
    <>
      <IonLabel className="ion-margin-start ion-text-uppercase">
        <strong>{title}</strong>
      </IonLabel>
      <IonList lines="none">
        {inspections.map((inspection) => (
          <IonCard
            key={inspection.id}
            button
            onClick={() => handleInspectionClick(inspection)}
          >
            <IonCardContent>
              <IonItem lines="none">
                <IonLabel>
                  <IonText>
                    {translations["lbl_inspection_id"] || "Inspection ID"}: {inspection.id}
                  </IonText>
                </IonLabel>
              </IonItem>         
              <IonItem lines="none">
                <IonLabel>
                  <IonText>
                    {translations["lbl_name"] || "Name"}:
                    <IonText color={inspection.required ? "danger" : "dark"}>
                      {" "}{inspection.name}
                    </IonText>
                  </IonText>
                </IonLabel>
              </IonItem>
              <IonItem lines="none">
                <IonLabel>
                  <IonText>
                    {translations["lbl_status"] || "Status"}:
                    <IonText color={inspection.status === "Completed" ? "success" : inspection.status === "Failed" ? "danger" : "warning"}>
                      {" "}{inspection.status}
                    </IonText>
                  </IonText>
                </IonLabel>
              </IonItem>
            </IonCardContent>
          </IonCard>
        ))}
      </IonList>
    </>
  );
};

export default InspectionGroupList;
